import { useState } from 'react';
import { Pagination } from '../components/Pagination';
import { useParams } from 'react-router-dom';
import { useSelector } from "react-redux";
import { BookDebateForm } from './BookDebateForm';
import { BookDebateListItem } from './BookDebateListItem';
import { useQuery } from "@tanstack/react-query";
import Api from 'utils/api/Api';
import { Loading } from 'app/components/Loading';

export const BookDebateSubList = ({ debate }) => {
    const { isbn } = useParams();
    const [page, setPage] = useState(0);
    const auth = useSelector(state => state.auth);

    const { data: bookDebateSubList, isFetching } = useQuery({
        queryKey: ['book/debate/sub/list', debate.id, page],
        queryFn: () => Api.get(`/api/book/${isbn}/debate/${debate.id}/list?page=${page}`),
        // placeholderData:keepPreviousData

    });

    const fetchList = (newPage = 0) => {
        setPage(newPage);
    }

    if (debate === null) return null;
    return (
        <div className="reply_inner">
            {auth.authenticated && debate.deleteYn === 'N' &&
                <BookDebateForm mode="reply" comment={debate} rootId={debate.id} page={page} placeholder="댓글을 적어보세요." className="reply_write" setPage={() => setPage(0)} />
            }

            {bookDebateSubList?.data?.list.length === 0 && <div className="no_data"><p>등록된 댓글이 없습니다.</p></div>}
            {bookDebateSubList?.data?.list.map((debateItem) => <BookDebateListItem key={debateItem.id} isbn={isbn} debate={debateItem} rootId={debate.id} page={page} auth={auth} useReplyWriteBtn={true} />)}
            <Loading overlay={true} active={isFetching} />
            <Pagination page={bookDebateSubList?.data?.page} totalPage={bookDebateSubList?.data?.totalPages} gotoPage={fetchList} />
        </div>
    );
}